<template>
  <div :class="classes">
    <div :class="containerClasses">
      <m4-page-heading><slot></slot></m4-page-heading>
      <div v-if="breadcrumbs && breadcrumbs.length" class="page-title__breadcrumbs">
        <div v-for="(breadcrumb, index) in breadcrumbs" :key="index" class="page-title__breadcrumbs__item">
          <a :href="breadcrumb.link" class="page-title__breadcrumbs__item__link">{{ breadcrumb.title }}</a>
          <m4-icon v-if="index !== breadcrumbs.length - 1" icon="angle-right"></m4-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "M4PageTitle",
  props: {
    size: {
      type: String,
      default() {
        return "desktop";
      }
    },
    breadcrumbs: {
      type: Array,
      default() {
        return [];
      }
    },
    fluid: Boolean
  },
  computed: {
    classes() {
      let classes = ["page-title"];

      if (this.fluid) {
        classes.push("page-title--is-fluid");
      }

      return classes;
    },
    containerClasses() {
      let classes = ["container"];
      if (!this.fluid) {
        classes.push("container--" + this.size);
      }
      if (this.fluid) {
        classes.push("is-fluid");
      }
      return classes;
    }
  }
};
</script>
